function patchObj(obj: { [key: string]: any }, pathToField: string, value: any): { [key: string]: any } {
  const patchedObj = { ...obj };

  const fieldPath = pathToField.split('.');

  if (fieldPath.length === 1) {
    patchedObj[fieldPath[0]] = value;
  } else {
    let targetField = patchedObj;

    const lastPath = fieldPath.reduce((prevPath, currPath, i) => {
      if (i < fieldPath.length - 1) {
        targetField = targetField[currPath];
      }

      return currPath;
    }, '');

    targetField[lastPath] = value;
  }

  return patchedObj;
}

export default patchObj;
